import { useState, useEffect } from 'react';
import {collection, query, where, getDocs, doc, deleteDoc, updateDoc, arrayUnion, arrayRemove, addDoc} from "firebase/firestore";
import { db } from '../firebaseInit';
import {getLastEntry} from "../utils/utils";
import { v4 as uuidv4 } from 'uuid';

export const usePortfolioNavUpdates = (accountId) => {
    const [navUpdates, setNavUpdates] = useState([]);
    const [cacheLastInvalidatedAt, setCacheLastInvalidatedAt] = useState(Date.now());

    useEffect(() => {
        const fetchPortfolioNavUpdates = async () => {
            try {
                const q = query(collection(db, "portfolioNavUpdates"), where("userId", "==", accountId));

                const querySnapshot = await await getDocs(q);

                const portfolioNavUpdates = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                console.log('usePortfolioNavUpdates portfolioNavUpdates: ', portfolioNavUpdates)

                setNavUpdates(portfolioNavUpdates);
            } catch (error) {
                console.error("Error fetching expenses: ", error);
            }
        };

        if (accountId) {
            fetchPortfolioNavUpdates();
        }
    }, [accountId, cacheLastInvalidatedAt]);

    const addPortfolioNav = async ({amountInCents, loggedAt, isInvestment}) => {
        try {
            await addDoc(collection(db, "portfolioNavUpdates"), {
                userId: accountId,
                amountInCents: amountInCents,
                loggedAt: new Date(loggedAt),
                isInvestment: isInvestment || false
            });
            setCacheLastInvalidatedAt(Date.now())
        } catch (error) {
            console.error("Error adding document: ", error);
        }
    }

    const removePortfolioNav = async (id) => {
        try {
            const docRef = doc(db, "portfolioNavUpdates", id);
            await deleteDoc(docRef);
            setCacheLastInvalidatedAt(Date.now())
        } catch (error) {
            console.error("Error adding document: ", error);
        }
    }

    return { navUpdates, addPortfolioNav, removePortfolioNav };
};

